// Re-export zentrale Plan-Katalog-Logik (shared mit Backend)
export {
  PLAN_ORDER,
  PLAN_LABELS,
  normalizePlanId,
  formatPlanLabel,
  isEarlyAdopterPricingActive,
  isUnlimitedPlan,
  getPlanTxLimit,
  getPlanPriceEUR,
  getUpgradePriceEUR,
  resolvePlanTxLimit,
  exceedsTxPlanLimit,
  formatTxLimitDisplay,
  getPlanDiscountPercent,
  getPlanSavingsEUR,
} from "./planCatalog.js";

import {
  getPlanTxLimit,
  getPlanPriceEUR,
  getPlanInfo as getPlanInfoFromCatalog,
  isEarlyAdopterPricingActive,
} from "./planCatalog.js";

/** @deprecated Nutze getPlanTxLimit — behält API für bestehende Imports */
export const PLAN_LIMITS = {
  free: 100,
  standard: 1000,
  pro: 3000,
  elite: 10000,
  ultimate: null,
};

function buildPlanInfoMap() {
  const early = isEarlyAdopterPricingActive(
    typeof import.meta !== "undefined" ? import.meta.env : {}
  );
  const ids = ["free", "standard", "pro", "elite", "ultimate"];
  const map = {};
  for (const id of ids) {
    const info = getPlanInfoFromCatalog(id, { earlyAdopter: early });
    if (!info) continue;
    map[id] = {
      name: info.name,
      transactionLimit: info.unlimited ? null : info.transactionLimit,
      unlimited: info.unlimited,
      price: info.price,
      features: [],
    };
  }
  return map;
}

export const PLAN_INFO = buildPlanInfoMap();

export function getPlanInfo(planName) {
  const early = isEarlyAdopterPricingActive(
    typeof import.meta !== "undefined" ? import.meta.env : {}
  );
  return getPlanInfoFromCatalog(planName, { earlyAdopter: early });
}

export function getPlanLimit(planName) {
  return getPlanTxLimit(planName);
}

export function isPlanLimitValid(planLimit, planName) {
  const expected = getPlanTxLimit(planName);
  if (expected == null) return planLimit == null || !Number.isFinite(Number(planLimit));
  return Number(planLimit) === expected;
}
